import React from 'react';
import { AppBar, Toolbar, Box, Typography, Chip } from '@mui/material';
import AccountMenu from './AccountMenu';

/**
 * Top bar shared by every staff-facing admin page (AdminDashboard,
 * UserDetail): logo, title, ADMIN chip, and the shared account menu. It was
 * duplicated byte-for-byte across both pages; this is the single copy.
 *
 * UserAppBar is the counterpart for the pages a user sees as themselves. The
 * two are separate components rather than one behind a flag: the difference is
 * audience, and a flag would put this bar's admin branding one mistaken prop
 * away from a customer's own account page. The menu is shared even so — see
 * AccountMenu for why it is the same list on every page.
 *
 * Deliberately self-contained rather than prop-driven: the title and menu do
 * not vary by page today, so there is nothing here for a caller to
 * parameterise. A page-specific breadcrumb (UserDetail has one, AdminDashboard
 * does not) renders separately, below this bar, inside each page's own
 * Container — moving it in here would change its width and padding, which is a
 * visual change this extraction must not make.
 */
function StaffAppBar() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Box
          component="img"
          sx={{
            height: 40,
            width: 40,
            mr: 2,
          }}
          alt="FiStone Logo"
          src="/fistone-logo.png"
        />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          FiStone Admin Dashboard
        </Typography>
        <Chip
          label="ADMIN"
          color="warning"
          size="small"
          sx={{ mr: 2 }}
        />
        <AccountMenu />
      </Toolbar>
    </AppBar>
  );
}

export default StaffAppBar;
